import { Theme } from '@material-ui/core';

import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { mergeDeep } from '@/utils/mergeDeep';

export const commonStyles = (
  theme: Theme,
  fieldVariant: FieldVariant,
  borderBottomStyle: string,
  disabledColor: string,
  highlightLabel = false,
) => {
  const labelColor = highlightLabel ? theme.palette.text.primary : theme.palette.text.secondary;

  const commonStyles = {
    root: {
      margin: 0,
      '& .MuiInputBase-input': {
        fontSize: theme.typography.subtitle2.fontSize,
        fontWeight: 700,
        marginRight: 1,
        marginTop: '0.2rem',
        textAlignLast: 'none',
        ...(fieldVariant === FieldVariant.form
          ? {
              overflow: 'hidden !important',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }
          : {}),
      },
      '& .MuiInputAdornment-root': {
        maxWidth: '100%',
        fontWeight: 400,
        color: theme.palette.text.secondary,
      },
      '& .MuiInputAdornment-positionStart p': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.subtitle2.fontSize,
        fontWeight: 700,
      },
      '& .MuiInputAdornment-positionEnd': {
        marginBottom: '6px',
        position: 'absolute',
        right: 0,
      },
      '& .MuiInputLabel-formControl': {
        color: `${labelColor} !important`,
        fontSize: '0.875rem',
        zIndex: 9,
      },
      '& .MuiInputLabel-shrink': {
        color: `${labelColor} !important`,
        fontSize: '0.875rem',
      },
      '& :before': {
        borderBottom: borderBottomStyle,
      },
      '& .Mui-disabled:before': {
        borderBottom: borderBottomStyle,
      },
      '& .Mui-disabled': {
        color: disabledColor,
      },
      '& .MuiSelect-icon.Mui-disabled': {
        display: 'none',
      },
      '& .MuiFormHelperText-root': {
        color: theme.palette.error.main,
      },
      '& .Mui-error:after': {
        borderBottomColor: `${theme.palette.error.main} !important`,
      },
      '& .MuiSelect-select': {
        color: theme.palette.text.primary,
      },
      '& .MuiSelect-select.Mui-disabled': {
        color: disabledColor,
      },
    },
  };

  const specialStyles = {
    [FieldVariant.dataRow]: {
      root: {
        '& .MuiInput-formControl': {
          marginTop: '0.5rem',
          paddingBottom: '0.65rem',
          marginBottom: '0.15rem',
        },
        '& .MuiFormControl-root': {
          margin: 0,
        },
        '& .MuiInputBase-input': {
          justifyContent: 'end',
          textAlign: 'right',
        },
        '& .MuiInput-inputMultiline': {
          marginTop: '-0.18rem', // 3px
        },
        '& .MuiInputAdornment-root': {
          marginTop: '-0.2rem',
        },
      },
    },
    [FieldVariant.form]: {
      root: {
        '&.MuiInput-formControl': {
          marginTop: '6.5px',
          marginBottom: 0,
        },
        '& .MuiFormControl-root': {
          margin: 0,
        },
        '& .MuiInputBase-input': {
          paddingTop: '0.6rem',
          paddingBottom: '0.2rem',
          minHeight: '1.75rem',
          display: 'flex',
          minWidth: '100%',
        },
        '& .MuiInput-inputMultiline': {
          marginTop: '6px',
          whiteSpace: 'wrap',
        },
        '& .MuiInputAdornment-root': {
          marginTop: '9px',
        },
      },
    },
  };

  return mergeDeep(commonStyles, specialStyles[fieldVariant]);
};
